<template>
  <div class="content">
    <loading-spinner v-if="isLoading"></loading-spinner>
    <div v-else>
      <EditProfileForm :title="formTitle" :button="formButton" :fields="fields" :member="member"
        @save-member="handleSubmit"></EditProfileForm>
      <div>
        <SimpleCard v-if="member.sns_account_provider">
          <template v-slot:title>
            <div class="simple-card-title">{{ member.sns_account_provider }} 계정으로 가입</div>
          </template>

          <template v-slot:sub-title>
            <div class="simple-card-sub-title">{{ member.sns_account_email }}</div>
          </template>
        </SimpleCard>
      </div>
    </div>
  </div>
</template>

<script>
import EditProfileForm from "@/components/specific/Profile/EditProfileForm.vue";
import SimpleCard from "@/components/cards/SimpleCard.vue"
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';

import { userInfo } from '@/views/ProfileView/fields';
import { savePopup, success } from '@/views/ProfileView/popups';


import { memberApi } from "@/api/api";

export default {
  components: {
    EditProfileForm,
    SimpleCard,
    LoadingSpinner,
  },
  data() {
    return {
      formTitle: "내 정보 수정",
      formButton: {
        name: "저장",
      },
      fields: userInfo,
      member: {
        idx: null,
        name: null,
        name_eng: null,
        member_type: null,
        personal_info: null,
        phone: null,
        country: null,
        email: null,
        organization: null,
        department: null,
        position: null,
        sns_account_provider: null,
        sns_account_email: null,
      },
      isLoading: false,
    }
  },
  methods: {
    async getMember() {
      this.isLoading = true;
      memberApi.getMember(this.member).then(res => {
        this.member = res ? res.data.response : this.member;
        this.isLoading = false;
      }).finally(() => {
        this.isLoading = false;
      });
    },

    async handleSubmit(member) {
      const isConfirmed = await savePopup();

      if (!isConfirmed) {
        return;
      }

      const isSuccess = await this.updateMember(member);

      if (isSuccess) {
        return await success();
      }
    },
    async updateMember(member) {
      this.isLoading = true;
      return memberApi.updateMember(member).then(res => {
        if (res && res.status === 200) {
          this.getMember();
          return true;
        }

        return false;
      }).finally(() => {
        this.isLoading = false;
      });
    }
  },
  mounted() {
    this.member.idx = this.userId;
    this.getMember();
  },
  computed: {
    userId() {
      return this.$store.getters["auth/userId"];
    }
  }
};
</script>
<style lang="scss">
.text-right {
  display: flex;
}

.simple-card-title {
  color: #565656;
  font-weight: 500;
  font-size: medium;
}

.simple-card-sub-title {
  color: gray;
  font-size: small;
}
</style>
